import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  DEFAULT_THEME: string = 'light';

  theme = signal<string>(localStorage.getItem('theme') ??
    (window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark' : this.DEFAULT_THEME));

  themeEffRef = effect(() => {
    this.applyTheme(this.theme());
    localStorage.setItem('theme', this.theme());
  });

  setTheme(newTheme: string) {
    this.theme.set(newTheme)
  }

  private applyTheme(newTheme: string) {
    const htmlElement = document.querySelector('html')!;
    const appliedTheme = htmlElement.getAttribute('data-bs-theme');
    if (newTheme == appliedTheme) return;
    else if (newTheme == this.DEFAULT_THEME) {
      htmlElement.removeAttribute('data-bs-theme');
      localStorage.removeItem('theme');
      // TODO Dark theme disabled until css will be ready
    } /*else {
      htmlElement.setAttribute('data-bs-theme', newTheme);
      localStorage.setItem('theme', newTheme);
    }*/
  }
}
